<script>
	import { getContext } from "svelte";
	import { px, percent } from "../utils";
	import { gasStopFirst } from "../stores";
	import { fade, blur, fly, slide, scale } from "svelte/transition";
	import { tweened } from "svelte/motion";
	import { quintOut } from "svelte/easing";

	import { animationParameters } from "../stores";

	const { padding, xRange, xScale, yRange, yScale, width, height, data, xGet } =
		getContext("LayerCake");

	export let color = "#999";
	export let label = "";

	$: value = $gasStopFirst.date;
	$: validDate = value.getYear() < 3000;

	$: valuePos = $xScale(value);
	const tValuePos = tweened(valuePos, $animationParameters);
	$: if (validDate) tValuePos.set(valuePos);

	$: console.log();
</script>

<div
	class="indicator-x-container"
	style:left={percent($tValuePos)}
	class:left={$tValuePos < 20}
	style:height={percent($yScale(0))}
	transition:fade
>
	{#if validDate}
		<!-- <div class="label" style:color>{@html label}</div> -->
		<div
			class="indicator-x"
			transition:scale={{ duration: 500, delay: 0, opacity: 0.5, start: 0, easing: quintOut }}
		>
			<div class="line" style:background-color={color} />
		</div>
	{/if}
</div>

<style lang="scss">
	$handle-size: 30px;

	.indicator-x-container {
		position: absolute;
		height: 100%;
		transform: translateX(-50%);
	}

	.indicator-x {
		display: flex;
		height: 100%;
		flex-direction: column;
		align-items: center;
	}

	.octagon {
		border-radius: 50%;
		width: 8px;
		height: 8px;
		background-color: white;
		border: 1px solid;
	}

	.line {
		height: 100%;
		width: 2px;
	}

	.label {
		font-weight: 400;
		font-size: 10px;
		line-height: 11px;
		letter-spacing: 0.04em;
		text-align: right;
		position: absolute;
		transform: translate(-110%, 0%);
	}

	.left {
		.label {
			text-align: left;
			transform: translate(25%, 0%);
		}
	}
</style>
